import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ReportControls, ReportView, type ReportControlsState } from '../../../../components/kyckConnect/ReportView';
import { CenteredSpinner } from '../../../../components/ui/Spinner';
import { KcPage } from './KcPage';
import { fetchPortalKcClubs, fetchPortalReport } from './portalSetupApi';

// THE CLUB'S KYCKCONNECT REPORTING (Phase 3, commit 6): the shared report in the Kyck Design System look. The page asks the portal
// endpoint only; the server scopes to the viewer's clubs and the strict query has no Brand or Group key.

export function PortalReportingPage() {
  const [controls, setControls] = useState<ReportControlsState>({ months: 6, grouping: 'week', compare: false });
  const [club, setClub] = useState<string | null>(null);
  const clubs = useQuery({ queryKey: ['portal-kc', 'clubs'], queryFn: fetchPortalKcClubs, retry: false });
  const report = useQuery({ queryKey: ['portal-kc', 'report', club, controls], queryFn: () => fetchPortalReport({ club, ...controls }), retry: false });
  const list = clubs.data?.clubs ?? [];
  return (
    <KcPage title="Reporting" intro="How your leads have been handled over the last few months." testId="portal-reporting-theme">
      <div className="mb-4 flex flex-wrap items-center gap-3">
        <ReportControls value={controls} onChange={setControls} />
        {list.length > 1 && (
          <select aria-label="Club" className="kc-field" value={club ?? ''} onChange={(e) => setClub(e.target.value || null)}>
            <option value="">All my clubs</option>
            {list.map((c) => <option key={c.accountId} value={c.accountId}>{c.name}</option>)}
          </select>
        )}
      </div>
      {report.isLoading ? <CenteredSpinner /> : report.isError || !report.data ? <p className="text-muted-foreground">We could not load the report. Try again in a moment.</p> : <ReportView report={report.data} polished />}
    </KcPage>
  );
}
